import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  reportIsVisibleSelector,
  supplierSpendDataSelector,
  supplierSpendFiltersSelector,
} from '../../../../../store/selectors/reportsSelectors';
import Pagination from '../../../../../core/components/pagination/Pagination';
import { setSupplierSpendReportFilters } from '../../../../../store/slices/reportsSlice';
import { getSupplierSpendReportThunk } from '../../../../../store/thunks/reports/reportsThunks';
import { BIG_TABLES_PAGE_SIZES } from '../../../../../core/utils/regex';
import SupplierSpendTable from './table/SupplierSpendTable';

const SupplierSpendContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(supplierSpendFiltersSelector);
  const tableData = useAppSelector(supplierSpendDataSelector);
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);

  return (
    <>
      <div className="actions-and-paging">
        <Pagination
          currentPage={filters.page}
          pageSize={filters.pageSize}
          totalItems={tableData.totalCount}
          onChange={(page, pageSize) => {
            const newFilters = { ...filters, page, pageSize };
            dispatch(setSupplierSpendReportFilters(newFilters));
            reportIsVisible && dispatch(getSupplierSpendReportThunk({ filters: newFilters }));
          }}
          className="actions-and-paging__paging"
          pageSizeOptions={BIG_TABLES_PAGE_SIZES}
          narrow
        />
      </div>
      <SupplierSpendTable />
    </>
  );
};

export default SupplierSpendContent;
